"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = exports.GridItem = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const lib_1 = require("../lib");
const GridWrapper = app_1.styled.div `
  display: grid;
  grid-template-columns: ${(_theme, $props) => $props.$templateColumns};
  grid-template-rows: ${(_theme, $props) => $props.$templateRows};
  grid-gap: ${(theme, { $gap }) => $gap
    ? (0, lib_1.isNominalSpacingValue)($gap)
        ? $gap
        : theme.spacing[$gap]
    : 'unset'};
`;
const ItemWrapper = app_1.styled.div `
  grid-row: ${(_theme, { $rowSpan }) => $rowSpan ? `span ${$rowSpan}` : 'auto'};
  grid-column: ${(_theme, { $colSpan }) => $colSpan ? `span ${$colSpan}` : 'auto'};
  ${(theme, { $center }) => $center && theme.flexCenter}
`;
function GridItem({ rowSpan, colSpan, noCenter, children, className, }) {
    return ((0, jsx_runtime_1.jsx)(ItemWrapper, Object.assign({ className: className, "$rowSpan": rowSpan, "$colSpan": colSpan, "$center": !noCenter }, { children: children })));
}
exports.GridItem = GridItem;
exports.Grid = (0, react_1.forwardRef)(({ templateColumns, templateRows, gap, children, className }, ref) => ((0, jsx_runtime_1.jsx)(GridWrapper, Object.assign({ ref: ref, className: className, "$templateColumns": templateColumns, "$templateRows": templateRows, "$gap": gap }, { children: children }))));
